import { ALL_KNOWN_DETAILS_TESTIDS, KNOWN_VALUE_BULLET, KNOWN_VALUE_GLYPH_ICON } from '../../constants';
import { displayValueFor, maskedHintFor } from '../../utils/allKnownDetailsUtils';
import type { KnownDetailType, KnownValue } from '../../types';
import styles from './KnownValueList.module.scss';

interface KnownValueListProps {
    values: KnownValue[];
    type: KnownDetailType;
}

/** Every type stacks one value per line, marked by the type's glyph where it has one and a bullet where it doesn't. */
const KnownValueList = ({ values, type }: KnownValueListProps) => {
    const glyphIcon = KNOWN_VALUE_GLYPH_ICON[type];
    const glyphTestId = `${ALL_KNOWN_DETAILS_TESTIDS.GLYPH}-${type}`;

    return (
        <div className={styles.ValueList} data-testid={ALL_KNOWN_DETAILS_TESTIDS.VALUE_LIST}>
            {values.map((value, index) => (
                <span className={styles.ValueCell} key={`${value.value}-${index}`} data-testid={ALL_KNOWN_DETAILS_TESTIDS.VALUE}>
                    {glyphIcon ? (
                        <img src={glyphIcon} alt="" aria-hidden="true" className={styles.ValueGlyphIcon} data-testid={glyphTestId} />
                    ) : (
                        <span className={styles.ValueBullet} aria-hidden="true" data-testid={glyphTestId}>
                            {KNOWN_VALUE_BULLET}
                        </span>
                    )}
                    <span className={styles.ValueText} title={maskedHintFor(value.value, type)}>
                        {displayValueFor(value.value, type)}
                    </span>
                </span>
            ))}
        </div>
    );
};

export default KnownValueList;
